const baseFontFamilyData = {};
const FontFamilyData = {
  fromJSON(object) {
    const message = { ...baseFontFamilyData };
    message.value = object.value !== void 0 && object.value !== null ? String(object.value) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.value !== void 0 && (obj.value = message.value);
    return obj;
  }
};
export {
  FontFamilyData
};
//# sourceMappingURL=decoration_fontfamily.js.map
